module.exports = __webpack_public_path__ + "static/media/signage-indoor-img58.4521e1b1.jpg";